/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/27
 */

const prefix = '魅族 mCycle 以旧换新 - ';

const setTitle = (suffix) => {
  document.title = prefix + suffix;
};

export default setTitle;



// WEBPACK FOOTER //
// ./src/utils/setTitle.js